import React, { useState, useEffect } from 'react';

import operatingPowerMeter from '../../../main/assets/images/powerMeterV2/operating-with-power-meter.webp';

export const ConnectionBoost = () => {
  const [isTabletLayout, setIstTabletLayout] = useState(false);
  const [isSmallMobileLayout, setIsSmallMobileLayout] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIstTabletLayout(width <= 1200);
      setIsSmallMobileLayout(width <= 767);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderTitle = () => {
    if (isSmallMobileLayout) {
      return (
        <>
          <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
            One tool
          </span>
          <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
            Total flight
          </span>
          <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
            confidence
          </span>
        </>
      );
    } else if (isTabletLayout) {
      return (
        <>
          <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
            One tool
          </span>
          <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
            Total flight confidence
          </span>
        </>
      );
    }
    return (
      <>
        <span style={{ whiteSpace: 'nowrap', display: 'block' }}>One tool</span>
        <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
          Total flight confidence
        </span>
      </>
    );
  };

  return (
    <div
      className={`power-meter-boost ${isTabletLayout ? 'mobile-layout' : ''}`}
    >
      <div className="power-meter-boost-content">
        <div className="power-meter-boost-text-container">
          <h2 className="power-meter-boost-title">{renderTitle()}</h2>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="659"
            height="2"
            viewBox="0 0 659 2"
            fill="none"
          >
            <path d="M0 1H659" stroke="url(#paint0_linear_1000_5182)" />
            <defs>
              <linearGradient
                id="paint0_linear_1000_5182"
                x1="0"
                y1="1.5"
                x2="659"
                y2="1.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.509" stopColor="#FF2238" />
                <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>

          <div className="dreamX__discover--button">
            <a
              href="https://shop.orqafpv.com/products/immersionrc-immersionrc-rf-power-meter-v2"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              buy now
            </a>
          </div>
        </div>
      </div>

      <div className="power-meter-boost-image-container">
        <img
          src={operatingPowerMeter}
          className="power-meter-boost-img"
          alt="Close-up of a hand operating with the ImmersionRC v2 product"
        />
      </div>
    </div>
  );
};
